<template>
    <!-- explicit background: the theme's "transparent" is an 8-digit hex Vuetify renders as black -->
    <v-list :color="backgroundColor" class="py-0">
        <template v-for="(locale, index) in locales">
            <v-list-item :key="locale.code" :ripple="false" @click="select(locale.code)">
                <v-list-item-icon class="mr-4">
                    <v-icon v-if="locale.code === current" :color="activeColor">mdi-check-circle</v-icon>
                    <v-icon v-else :color="iconColor">mdi-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title :style="{ color: color }">{{ locale.name }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index < locales.length - 1" :key="`${locale.code}-divider`" inset/>
        </template>
    </v-list>
</template>

<script>
import i18n from '@/locale/i18n';
import { mapState } from 'vuex';
import { getSupportedLocales } from '@/locale/supported-locales.js';
import { layoutMixin } from '@/utils/layout-mixin';

export default {
    mixins: [layoutMixin],
    props: {
        color: {
            type: String,
            default: null,
        },
        iconColor: {
            type: String,
            default: null,
        },
        activeColor: {
            type: String,
            default: null,
        },
        backgroundColor: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapState('settings', ['app_locale']),
        locales() {
            return getSupportedLocales();
        },
        current() {
            return String(this.app_locale || this.$i18n.locale || '').toLowerCase();
        },
    },
    methods: {
        // language switch: store, both i18n instances and Vuetify
        select(code) {
            if (code === this.current) {
                return;
            }
            this.$store.commit('settings/SET_APP_LOCALE', code);
            this.$i18n.locale = code;
            i18n.locale = code;
            this.setLanguageInVuetify(code);
            this.$emit('change', code);
        },
    },
};
</script>
